import { render, staticRenderFns } from "./ManuscriptEditorMenuDialog.vue?vue&type=template&id=bbf53e54&scoped=true&"
import script from "./ManuscriptEditorMenuDialog.vue?vue&type=script&lang=ts&"
export * from "./ManuscriptEditorMenuDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ManuscriptEditorMenuDialog.vue?vue&type=style&index=0&id=bbf53e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf53e54",
  null
  
)

export default component.exports